import { keyframes } from "styled-components";

export const rotateAnimation = keyframes`
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
`;

export const increaseWidthAnimation = keyframes`
  from { left: 0; width: 5%; }
  to { left: 120%; width: 100%;}
`;
